import React from 'react';
import {
  ScrollableViewport,
  DetailedTimeseriesChart,
  TimeseriesChartItem,
} from '@ihsm/ui-shared';

export interface DetailsChartSegmentProps {
  chartData: TimeseriesChartItem[];
  isSearchTreeCollapsed: boolean;
  isSideBarCollapsed: boolean;
}

export const DetailsChartSegment: React.FC<DetailsChartSegmentProps> = ({
  chartData,
  isSearchTreeCollapsed,
  isSideBarCollapsed,
}) => (
  <ScrollableViewport vertical>
    <DetailedTimeseriesChart
      detailChartData={chartData}
      isSearchTreeCollapsed={isSearchTreeCollapsed}
      isSideBarCollapsed={isSideBarCollapsed}
    />
  </ScrollableViewport>
);
